import { render, staticRenderFns } from "./diseases_and_symptoms.form.vue?vue&type=template&id=320a1c26&scoped=true&"
import script from "./diseases_and_symptoms.form.vue?vue&type=script&lang=js&"
export * from "./diseases_and_symptoms.form.vue?vue&type=script&lang=js&"
import style0 from "./diseases_and_symptoms.form.vue?vue&type=style&index=0&id=320a1c26&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320a1c26",
  null
  
)

export default component.exports